import moment from 'moment'
import React from 'react'
import history from 'routes/history'
import PropTypes from 'prop-types'
import CrowdProgressBar from 'shared/helpers/crowd-progress'
import { parseTimeZone } from 'assets/localization'
import { timezoneAbbreviationLabel } from 'shared/helpers/user'
import Tooltip from 'components/controls/tooltip'

const invalidFilesWarning = `
  One or more files contain an upload error.
  You can manage your files from the main
  project overview to delete and re-upload.
`
const formatTime = (date, formatDate) => {
  return `${formatDate(date, 'MMMM Do YYYY, h:mma')}`
}

const ProjectListItem = ({
  id,
  name,
  modified_on,
  project_status_id,
  sample_size,
  salesforce_job_number,
  scheduled,
  completed,
  external_survey_id,
  project_status_name,
  formatDate,
  created_on,
  firstName,
  lastName,
  timeZone,
  topicName
}) => (
  <div className="list-item-container">
    <div className={`project-status ${(project_status_name || '').replace(/\s+/g, '-').toLowerCase()}`}>
      {project_status_name.toUpperCase()}
    </div>
    <div
      className="list-item-details project-details"
      onClick={() =>
        history.push(`/projects/${id}/dashboard`)
      }
    >
      <div className="list-item-content">
        <div className="list-item-project-info">
          <span className="list-item-project-name">
            {name}
            <div className="list-item-project-topic">
              {`Topic Name: ${topicName}`}
            </div>
          </span>
          <span className="list-item-date">{`Updated ${formatTime(modified_on, formatDate)} ${timezoneAbbreviationLabel(timeZone)}`}</span>
            <span className="list-item-date">Survey ID: {external_survey_id}  |  Salesforce Job Number: {salesforce_job_number} </span>
            <span className="list-item-date">Created by: {firstName} {lastName}, on {formatTime(created_on, formatDate)} {timezoneAbbreviationLabel(timeZone)}</span>
        </div>
        <CrowdProgressBar
          className=""
          requested={sample_size}
          scheduled={scheduled}
          completed={completed}
        />
      </div>
    </div>
  </div>
)

ProjectListItem.propTypes = {
  listItemUrl: PropTypes.string,
  projectStatus: PropTypes.string,
  name: PropTypes.string,
  modified_on: PropTypes.string,
}

export default ProjectListItem
